import { createIcon } from '@chakra-ui/react';

export const PinIcon = createIcon({
  displayName: 'PinIcon',
  viewBox: '0 0 12 14',
  path: (
    <path d="M2 6.066v-4.4A.667.667 0 0 1 2 .334h8a.667.667 0 1 1 0 1.334v4.4c.621.68.955 1.356 1.133 1.889.097.292.147.54.173.72a2.936 2.936 0 0 1 .027.287V9s-.002-.087 0 .001a.667.667 0 0 1-.666.667h-4V13a.667.667 0 1 1-1.333 0V9.667h-4A.667.667 0 0 1 .667 9c0-.333 0 0 0 0v-.014a1.363 1.363 0 0 1 .004-.09 4.149 4.149 0 0 1 .197-.94A5.292 5.292 0 0 1 2 6.066Zm6.667-4.4H3.334v4.667c0 .177-.07.347-.196.472-.564.564-.847 1.119-.99 1.528h7.705c-.143-.41-.426-.964-.99-1.528a.667.667 0 0 1-.196-.472V1.667Z" />
  ),
});
